import { useState } from "react";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import SalesPage from "./SalesPage";
import ProductsPage from "./ProductsPage";
import CustomersPage from "./CustomersPage";
import StockPage from "./StockPage";
import ExpensesPage from "./ExpensesPage";
import ReportsPage from "./ReportsPage";
import SettingsPage from "./SettingsPage";
import RmbCalculationPage from "./RmbCalculationPage";
import MBDSPage from "./MBDSPage";

export default function DashboardLayout() {
  const [active, setActive] = useState("RMB"); 
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const renderPage = () => {
    switch(active) {
      case "Sales":     return <SalesPage />;
      case "Products":  return <ProductsPage />;
      case "Customers": return <CustomersPage />;
      case "Stock":     return <StockPage />;
      case "Expenses":  return <ExpensesPage />;
      case "Reports":   return <ReportsPage />;
      case "Settings":  return <SettingsPage />;
      case "RMB":       return <RmbCalculationPage />; 
      case "MBDS":      return <MBDSPage />;
      default:          return <SalesPage />;
    }
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh", width: "100vw", overflow: "hidden", background: "#FFFFFF" }}>
      
      <div 
        className={`mobile-overlay ${sidebarOpen ? "open" : ""}`} 
        onClick={() => setSidebarOpen(false)} 
      />

      {/* Main Sidebar */}
      <div className={`sidebar-wrapper ${sidebarOpen ? "open" : ""}`}>
         <Sidebar active={active} setActive={(page) => { setActive(page); setSidebarOpen(false); }} />
      </div>

      {/* Main Content Area */}
      <div className="main-wrapper">
         <Topbar active={active} toggleSidebar={() => setSidebarOpen(true)} />
         
         <div className="page-padding" style={{ flex: 1, overflowY: "auto", overflowX: "hidden", padding: "24px 32px" }}>
           {renderPage()}
         </div>
      </div>
      
    </div>
  );
}
